export default __webpack_public_path__ + "static/media/img-0589-poland-full-face.72e06755.png";